import React from 'react';
import { Link, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Help, HelpOutline } from '@material-ui/icons'
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import {
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER
} from 'constants/ActionTypes';
import SearchNotyfileBox from 'components/notyfileSearch';
import SearchBox from 'components/SearchBox/indexN';
import MailNotification from '../MailNotification/index';
import AppNotification from '../AppNotification/index';
import { Button, Box, Badge } from '@material-ui/core';
import CardHeader from './CardHeader';
import { switchLanguage, toggleCollapsedNav } from 'actions/Setting';
import { 
  setSeenNotis,getMyUserProfilePic,setToastrThisNotis,setAFNotisSeen,onRefeshOutlookToken,
  getAFNotis,setofUpdatedashboardisMessage
} from 'actions';
import IntlMessages from 'util/IntlMessages';
import LanguageSwitcher from 'components/LanguageSwitcher/index';
import Menu from 'components/TopNav/Menu';
import UserInfoPopup from 'components/UserInfo/UserInfoPopup';
import isEmpty from 'lodash/isEmpty'
import PopUpSA from 'app/routes/SkapaNyAvtal/PopUpSA'
import PopUpSP from 'app/routes/SkapaNyProspekt/PopUpSP'
import PopUpSO from 'app/routes/SkapaOrder/PopUpSO'
import PopUpBM from 'app/routes/Möte/SkapaEvent/PopUpBM'
import PopUpES from 'app/routes/SkapaEsignering/PopUpES'
import PopUpAk from 'app/routes/SkapaNyAktiv/PopUpAk2'
import PopUpTR from 'app/routes/SkapaTidsrapport/PopUpSkapaTidsrapport'
import PopUpSkapaKund from 'app/routes/SkapaKund/PopUpSkapaKund'
import PopUpSkapaAFNotis from 'app/routes/SkapaAFNotis/PopUpSkapaAFNostis'
import {isUndefined} from 'lodash'
import HelpIcon from '../../assets/images/icons/Help.png'
import { toast, ToastContainer } from 'react-toastify';
import compose from 'recompose/compose'
import {withStyles} from '@material-ui/styles'

import 'react-toastify/dist/ReactToastify.css';
import NotisItemAF from './NotisItemAF';




class Header extends React.Component {

  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification
    })
    
    this.setSeenNotis()
  };
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification
    })
  };
  onLangSwitcherSelect = (event) => {
    this.setState({
      langSwitcher: !this.state.langSwitcher, anchorEl: event.currentTarget
    })
  };
  onSearchBoxSelect = (e) => {
    if(!e.target.dataset.preventclose && !e.target.parentElement.dataset.preventclose) {

      this.setState({
        searchBox: !this.state.searchBox
      })
    }
  };
  onAppsSelect = () => {
    this.setState({
      apps: !this.state.apps
    })
  };
  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo
    })
  };
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      userInfo: false,
      Notification:this.props.Notification,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
      apps: false
    });
  };
  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };
  getSeverity=(icon)=>{
    switch(parseInt(icon)){
      case 1:return "warning"
      case 2:return "info"
      case 3:return "success"
      case 4:return "error"
      default:return "info"
    }
  }
  componentDidUpdate=(prevProps)=>{
    if(this.props.updatedashboardisMessage === 1){
      this.props.getAFNotis(this.props.authUser.user_id, this.props.authUser.user_Afid, 0, 1,this.props.authUser.user_OfficeId)
      this.props.setofUpdatedashboardisMessage()      
    }
    if(this.state.Notification !== this.props.Notification){
      let seen = this.state.NotisSeen
      let _notis = this.props.Notification.filter(item=>{return parseInt(item.Toastr) === 0})

      
      for(let notis of _notis) { 
        console.log(_notis,"_notis")
        console.log(this.state.NotisSeen,"_notis")
        if(isEmpty(this.state.NotisSeen.find(s => s.id === notis.id))) { 
          toast.info(notis.Beskrivning, {
            position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              pauseOnFocusLoss: false,
              progress: 0,
              onOpen: () => this.setToasterTONull(this.props.authUser.user_id,notis.id)
          });
          seen.push(notis)
        }
      }

      // if(!isEmpty(this.state.Notification)){
      // let difference = this.props.Notification.filter(x => !this.state.Notification.includes(x)).filter(item=>{return parseInt(item.Toastr) === 0});
      // this.setState({
      //   Notification:this.props.Notification,
      //   difference:difference
      // })
      // }else{
      //   this.setState({
      //     Notification:this.props.Notification,
      //     difference:[]
      //   })
      // }
      this.setState({
        Notification: this.props.Notification,
        NotisSeen: seen,
      })
    }
    if(this.props.AFNotis !== this.state.AFNotis) {
      let seen = this.state.AFNotisSeen
      for(let notis of this.props.AFNotis) {
        if(isEmpty(this.state.AFNotisSeen.find(s => s.id === notis.id))) {
          toast.info(<NotisItemAF notis={notis}/>, {
            className: this.props.classes.AFNotis,
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            pauseOnFocusLoss: false,
            progress: 0,
            onOpen: () => this.props.setAFNotisSeen(this.props.authUser.user_id, this.props.authUser.user_Afid, notis.id)
          });
          seen.push(notis)
        }
      }
      this.setState({
        AFNotis: this.props.AFNotis,
        AFNotisSeen: seen,
      })
    }
  }
  Apps = () => {
    const { user_Afid, user_Email, user_Notification,
      user_SeeCasesList, user_SeeContractFlag, user_SeeDialer, user_SeeEndClients,
      user_SeeOrderList, user_SeeRinglist, user_WeekNotification, user_id, user_role
    } = this.props.authUser;
    //parseInt(this.props.authUser.user_role) === 5?"":
    return (
      <ul className="jr-list jr-list-half">
        {isUndefined(this.props.Flags)?"":this.props.Flags.Avtal === 1?
        parseInt(this.props.authUser.user_CanSeeContract) === 1?
        <li className="jr-list-item">
          <Button className="jr-list-link"
            onClick={this.handleClickOpenAvtal}
          >
            <Box p={0} >
              <Box flexGrow={1}>
                <Avatar variant="square"
                  style={{ margin: "0px auto" }}
                  src={require("assets/images/icons/Skapa avtal_2.png")}>
                </Avatar>
                <span className="jr-list-text"><small><IntlMessages id="Agreement.Create" /></small></span>

              </Box>
            </Box>
          </Button>
        </li>
        :""
        :""}
        {isUndefined(this.props.Flags)?"":this.props.Flags.Prospekt === 1?
         parseInt(this.props.authUser.user_CanSeeProspekt) === 1?
        <li className="jr-list-item">
          <Button className="jr-list-link"
            onClick={this.handleClickOpenProspekt}
          >
            <Box p={0} >
              <Box flexGrow={1}>
                <Avatar variant="square"
                  style={{ margin: "0px auto" }}
                  src={require("assets/images/icons/Nytt prospekt_2.png")}>
                </Avatar>
                <span className="jr-list-text"><small><IntlMessages id="Prospectus.Create.Short" /></small></span>
                </Box>
            </Box>
            </Button>
        </li>
        :""
        :""}
        {
        parseInt(this.props.authUser.user_Licans) === 1?"":
        isUndefined(this.props.Flags)?"":this.props.Flags.OrderF === 1?
        parseInt(this.props.authUser.user_SeeOrderList) === 1?
        <li className="jr-list-item">
          <Button className="jr-list-link"
            onClick={this.handleClickOpenSOrder}
          >
            <Box p={0} >
              <Box flexGrow={1}>
                <Avatar variant="square"
                  style={{ margin: "0px auto" }}
                  src={require("assets/images/icons/Skapa order_2.png")}>
                </Avatar>
                <span className="jr-list-text"><small><IntlMessages id="Order.Create" /></small></span>
              </Box>
            </Box>
          </Button>
        </li>
        :""
        :""}
        <li className="jr-list-item">
        <Button className="jr-list-link"
            onClick={this.handleClickOpenSKund}
          >
            <Box p={0} >
              <Box flexGrow={1}>
                <Avatar variant="square"
                  style={{ margin: "0px auto" }}
                  src={require("assets/images/icons/Skapa kund_2.png")}>
                </Avatar>
                <span className="jr-list-text"><small><IntlMessages id="Customer.Create" /></small></span>
              </Box>
            </Box>
          </Button>
        </li>
        
        {/*isUndefined(this.props.Flags)?"":this.props.Flags.Arende === 1?
        <li className="jr-list-item">
          <Link className="jr-list-link" to="/app/avtal">
            <i>
              <Avatar variant="square" src={require("assets/images/icons/Arenden.png")}>
              </Avatar>
            </i>
            <span className="jr-list-text"><small><IntlMessages id="Errand.Create" /></small></span>
          </Link>
        </li>
        :""*/}
        {isUndefined(this.props.Flags)?"":this.props.Flags.Kalender === 1?
         parseInt(this.props.authUser.user_CanSeeEvent) === 1?
        <li className="jr-list-item">
          <Button className="jr-list-link"
            onClick={this.handleClickOpenSEvent}
          >
            <Box p={0} >
              <Box flexGrow={1}>
                <Avatar variant="square"
                  style={{ margin: "0px auto" }}
                  src={require("assets/images/icons/Bokning_2.png")}>
                </Avatar>
                <span className="jr-list-text"><small><IntlMessages id="Meeting.Create" /></small></span>
              </Box>
            </Box>
          </Button>
        </li>
        :""
        :""}

        {
          isUndefined(this.props.Flags)?"":this.props.Flags.Aktiviteter === 1?
          parseInt(this.props.authUser.user_CanSeeAktiviteter) === 1?
        <li className="jr-list-item">
          <Button className="jr-list-link"
            onClick={this.handleClickOpenSAktivitet}
          >
            <Box p={0} >
              <Box flexGrow={1}>
                <Avatar variant="square"
                  style={{ margin: "0px auto" }}
                  src={require("assets/images/icons/Bokning_2.png")}>
                </Avatar>
                <span className="jr-list-text"><small><IntlMessages id="Activities.Create.Short" /></small></span>
              </Box>
            </Box>
          </Button>
        </li>
        :""
        :""
      }


        {isUndefined(this.props.Flags)?"":this.props.Flags.Esignering === 1
        ||
        this.props.Flags.GetAccept === 1
        ?
        parseInt(this.props.authUser.user_CanSeeEsignering) === 1?
        <li className="jr-list-item">
          <Button className="jr-list-link"
            onClick={this.handleClickOpenSEsignering}
          >
            <Box p={0} >
              <Box flexGrow={1}>
                <Avatar variant="square"
                  style={{ margin: "0px auto" }}
                  src={require("assets/images/icons/Esignering.png")}>
                </Avatar>
                <span className="jr-list-text"><small><IntlMessages id="E-signing" /></small></span>
              </Box>
            </Box>
          </Button>
          
        </li>
        :""
        :""}
        {
          isUndefined(this.props.Flags)?"":this.props.Flags.Projekt === 1?
          parseInt(this.props.authUser.user_SeeProjects) === 1?
          <li className="jr-list-item">
          <Button className="jr-list-link"
            onClick={this.handleClickOpenSTidsrapport}
          >
            <Box p={0} >
              <Box flexGrow={1}>
                <Avatar variant="square"
                  style={{ margin: "0px auto" }}
                  src={require("assets/images/icons/Bokning_2.png")}>
                </Avatar>
                <span className="jr-list-text"><small><IntlMessages id="TimeRepport" /></small></span>
              </Box>
            </Box>
          </Button>
          
        </li>
          :""
          :""
        }
       
        {
          this.props.authUser.user_role === 1 ?
          <li className="jr-list-item">
          <Button className="jr-list-link"
              onClick={this.handleClickOpenAFNotisOpen}
            >
              <Box p={0} >
                <Box flexGrow={1}>
                  <Avatar variant="square"
                    style={{ margin: "0px auto" }}
                    src={require("assets/images/icons/Skapa kund_2.png")}>
                  </Avatar>
                  <span className="jr-list-text"><small><IntlMessages id="Message" /></small></span>
                </Box>
              </Box>
            </Button>
          </li> : ''
        }
        
 
      </ul>)
  };

  constructor() {
    super();
    this.state = {
      anchorEl: undefined,
      searchBox: false,
      searchText: '',
      BText:0,
      searchy: 'Kund',
      mailNotification: false,
      userInfo: false,
      langSwitcher: false,
      appNotification: false,
      AvtalOpen: false,
      ProspektOpen: false,
      SOrderOpen: false,
      SEventOpen: false,
      SAktivitetOpen: false,
      SEsigneringOpen: false,
      SKundOpen: false,
      AFNotisOpen: false,
      difference:[],
      AFNotis: [],
      AFNotisSeen: [],

      NotisSeen: [],
      Notification: []
    }
  }
  handleClickOpenAvtal = () => {
    this.setState({ AvtalOpen: true })
  }
  handleCloseAvtal = () => { this.setState({ AvtalOpen: false }) }
  handleClickOpenProspekt = () => {
    this.setState({ ProspektOpen: true })
  }
  handleCloseProspekt = () => { this.setState({ ProspektOpen: false }) }
  handleClickOpenSKund = () => {
    this.setState({ SKundOpen: true })
  }
  handleCloseSKund  = () => { this.setState({ SKundOpen: false }) }
  handleClickOpenAFNotisOpen = () => { this.setState({ AFNotisOpen: true }) }
  handleCloseAFNotisOpen  = () => { this.setState({ AFNotisOpen: false }) }
  handleClickOpenSOrder = () => {
    this.setState({ SOrderOpen: true })
  }
  handleCloseSEvent = () => { this.setState({ SEventOpen: false }) }
  handleClickOpenSEvent = () => {
    const userid= this.props.authUser.user_id
    const Afid= this.props.authUser.user_Afid
    this.props.onRefeshOutlookToken(userid,Afid)
    this.setState({ SEventOpen: true })
  }
  handleCloseSAktivitet = () => { this.setState({ SAktivitetOpen: false }) }
  handleClickOpenSAktivitet = () => {
    this.setState({ SAktivitetOpen: true })
  }
  handleCloseSEsignering = () => { this.setState({ SEsigneringOpen: false }) }
  handleClickOpenSEsignering = () => {
    this.setState({ SEsigneringOpen: true })
  }
  handleCloseSTidsrapport = () => { this.setState({ STidsrapportOpen: false }) }
  handleClickOpenSTidsrapport= () => {
    this.setState({ STidsrapportOpen: true })
  }
  handleCloseSOrder = () => { this.setState({ SOrderOpen: false }) }
  updateSearchText(evt) {
		console.log(evt.target.value, 'value hcange')
    this.setState({
      searchText: evt.target.value,
    });
  }
  updateBText(Btext) {
    this.setState({
      BText: Btext,
    });
  }
  updateSearchtype(evt) {
    this.setState({
      searchy: evt.target.value,
    });
  }
  searchFor = () => {
    const { searchText,BText, searchy } = this.state;
    if (!isEmpty(searchText)) {
      if (searchy === "Kund") {
        this.props.history.push({
          pathname: '/app/SokKund',
          state: { searchText: searchText,BText:BText }
        })
        this.setState({
          searchBox: false,
          searchText:"",
          BText:BText
        });
      }
    }
  }
  _handleKeyPress = e => {
    if (e.key === "Enter") {
      const { searchText,BText, searchy } = this.state;
      if (!isEmpty(searchText)) {
        if (searchy === "Kund") {
          this.props.history.push({
            pathname: '/app/SokKund',
            state: { searchText: searchText,BText:BText }
          })
          this.setState({
            searchText:"",
            BText:BText
          });
        }
      }
    }
  };
  setSeenNotis=()=>{
    const userid= this.props.authUser.user_id
    this.props.setSeenNotis(userid)
  }
  componentWillMount=() => {
    const userid= this.props.authUser.user_id
    this.props.getMyUserProfilePic(userid)

  }
  componentDidMount=()=>{
    const BText = isUndefined(this.props.history.location.state)?0:isUndefined(this.props.history.location.state.BText)?0:this.props.history.location.state.BText;
    this.setState({
      BText:BText
    })
  }
  notify =(notification)=>{
    console.log(notification)
    const userid= this.props.authUser.user_id
   
        toast.info(notification.Beskrivning, {
          position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            pauseOnFocusLoss: false,
            progress: 0,
            onOpen: () => this.setToasterTONull(userid,notification.id)
        });
    
  }
  setToasterTONull=(userid,id)=>{
    this.props.setToastrThisNotis(userid,id)
    this.setState({
      difference:[]
    })
  }
  render() {
    const { classes } = this.props

    const { drawerType, locale, navigationStyle, horizontalNavPosition, navCollapsed } = this.props;
    const { user_fnamn, user_lnamn } = this.props.authUser;
    const drawerStyleq = drawerType.includes(FIXED_DRAWER) ? 'd-block d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-block' : 'd-none';
    const drawerStyle = 'd-block';
    let drawerStyleww = navCollapsed === true ? "Class22" : "Class12";
    const KalenderFlag = isUndefined(this.props.Flags)?false:this.props.Flags.Kalender;
    const EpostFlag = isUndefined(this.props.Flags)?false:this.props.Flags.Epost;
    console.log(this.props.width,"propswidth")
    return (
      <AppBar
        className={`app-main-header ${drawerStyleww} ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}`}>
        <Toolbar className="app-toolbar" disableGutters={false}>
        
          <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu"
            onClick={this.onToggleCollapsedNav}>
            <span className="menu-icon" />
          </IconButton>
       
          <SearchBox styleName="d-none d-lg-block w-100" placeholder=""
            onChange={this.updateSearchText.bind(this)}
            onChangeBText={this.updateBText.bind(this)}
            BText={this.state.BText}
            ontypeChange={this.updateSearchtype.bind(this)}
            value={this.state.searchText} 
            seachtype={this.state.searchy}
            searchFor={this.searchFor}
            handleKeyPress={this._handleKeyPress}
          />
          
          {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER) &&
            <Menu />}

          <ul className="header-notifications list-inline ml-auto">
          {
            
            parseInt(this.props.authUser.user_Licans) === 5?"":   
            parseInt(this.props.authUser.user_role) === 5?"":   
            <li className="list-inline-item">
              <Dropdown
                className="quick-menu app-notification"
                isOpen={this.state.apps}
                toggle={this.onAppsSelect.bind(this)}>

                <Tooltip title={<IntlMessages id="Shortcuts" />} aria-label={'Genvägar'}>
                  <DropdownToggle
                    className="d-inline-block"
                    tag="span"
                    data-toggle="dropdown"
                    >
                    <IconButton className="icon-btn" style={{height: parseInt(this.props.width)>700?36:24, width: parseInt(this.props.width)>700?36:24}}>
                      <i className="zmdi zmdi-plus zmdi-hc-fw zmdi-hc-lg" style={{fontSize:parseInt(this.props.width)>700?25:20}}/>
                    </IconButton>
                  </DropdownToggle>
                </Tooltip>
                {
                  isUndefined(this.props.Flags)?"":
                  parseInt(this.props.Flags.IsKedja) ===1                  
                  ?"":
                
                <DropdownMenu>
                  {this.Apps()}
                </DropdownMenu>
                }
              </Dropdown>
            </li>
            }
            {/*Jack 2023-08-18*/ }
            {
              parseInt(this.props.authUser.user_Licans) === 5?"": 
              parseInt(this.props.authUser.user_role) === 5?"":
              KalenderFlag===1?
              parseInt(this.props.authUser.user_CanSeeEvent) === 1?
              <li className="d-inline-block list-inline-item">
                <Tooltip title={<IntlMessages id="Calendar" />} aria-label={'Kalender'}>
                <Link to="/app/Kalender">
                <IconButton className="quick-menu text-white" size="small" style={{height: parseInt(this.props.width)>700?36:24, width: parseInt(this.props.width)>700?36:24}}>
                  <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-lg" style={{fontSize:parseInt(this.props.width)>700?23:20}}/>
                </IconButton>
              </Link></Tooltip>
              </li>
              :""
              :""
            }
            {
              parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"": 
              parseInt(this.props.authUser.user_role) === 5?"":
              EpostFlag===1?
              <li className="d-inline-block list-inline-item">
                <Tooltip title={<IntlMessages id="E-mail" />} aria-label={'E-post'}>
                <Link to="/app/Epost">
                <IconButton className=" quick-menu text-white" size="small" style={{height: parseInt(this.props.width)>700?36:24, width: parseInt(this.props.width)>700?36:24}}>
                  <i className="zmdi zmdi-email zmdi-hc-fw zmdi-hc-lg" style={{fontSize:parseInt(this.props.width)>700?24:20}}/>
                </IconButton>
              </Link>
              </Tooltip>
              </li>
              :""
            }
            {
              parseInt(this.props.authUser.user_Licans) >=3?
              <li className="d-inline-block list-inline-item">
                 <Tooltip title={<IntlMessages id="MainSearch" />} aria-label={'Supersök'}>
              <Link to="/app/search">
              <IconButton className=" quick-menu text-white" size="small" style={{height: parseInt(this.props.width)>700?36:24, width: parseInt(this.props.width)>700?36:24}}>
              <i class="zmdi zmdi-search-in-page zmdi-hc-fw zmdi-hc-lg" style={{fontSize:parseInt(this.props.width)>700?25:20}}/>
              </IconButton>
            </Link></Tooltip>
            </li>
              :""
            }
            {/*End Jack 2023-08-18*/ }
            <li className="d-inline-block d-lg-none list-inline-item">
              <Dropdown
                className="quick-menu nav-searchbox"
                isOpen={this.state.searchBox}
                toggle={this.onSearchBoxSelect.bind(this)}>

                
                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <IconButton className="icon-btn">
                    <i className="zmdi zmdi-search zmdi-hc-fw" />
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu className="p-0" style={{minWidth:300}}>
                  <SearchBox styleName="d-block d-lg-block w-100 color-dark" placeholder=""
                    onChange={this.updateSearchText.bind(this)}
                    ontypeChange={this.updateSearchtype.bind(this)}
                    value={this.state.searchText} seachtype={this.state.searchy}
                    searchFor={this.searchFor}
                    onChangeBText={this.updateBText.bind(this)}
                    BText={this.state.BText}
                  />
                </DropdownMenu>
              </Dropdown>
            </li>
            
            <li className="list-inline-item d-none">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.langSwitcher}
                toggle={this.onLangSwitcherSelect.bind(this)}>

                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <IconButton className="icon-btn">
                    <i className={`flag flag-24 flag-${locale.icon}`} />
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu right className="w-50">
                  <LanguageSwitcher switchLanguage={this.props.switchLanguage}
                    handleRequestClose={this.handleRequestClose} />
                </DropdownMenu>
              </Dropdown>


            </li>
            
            <li className="list-inline-item app-tour">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.appNotification}
                toggle={this.onAppNotificationSelect.bind(this)}>

                <Tooltip title={<IntlMessages id="Notification" />} aria-label={'Notifikationer'}>
                  <DropdownToggle
                    className="d-inline-block"
                    tag="span"
                    data-toggle="dropdown">
                    <Badge badgeContent={this.props.Notification.length} invisible={this.props.Notification.length === 0} color="secondary" 
                    classes={{anchorOriginTopRightRectangle: classes.badge}}>
                      <IconButton className="icon-btn">
                        {//TTT ${this.props.Notification.length !== 0?"icon-alert":""} 
                        }
                        <i 
                        style={{fontSize:parseInt(this.props.width)>700?23:20}}
                        className={`zmdi zmdi-notifications-none 
                        
                        ${this.props.Notification.filter(n=>{return n.Seen === 0}).length !== 0?"animated infinite wobble":""} 
                        `}
                        />
                      </IconButton>
                    </Badge>
                  </DropdownToggle>
                </Tooltip>

                <DropdownMenu right>
                  <CardHeader styleName="align-items-center" notificationLength={this.props.Notification.length}
                    heading={<IntlMessages id="Notification.title" />} />
                  <AppNotification />
                </DropdownMenu>
              </Dropdown>
            </li>
           
            <li className="list-inline-item mail-tour d-none">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.mailNotification}
                toggle={this.onMailNotificationSelect.bind(this)}
              >
                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">

                  <IconButton className="icon-btn">
                    <i className="zmdi zmdi-comment-alt-text zmdi-hc-fw" />
                  </IconButton>
                </DropdownToggle>


                <DropdownMenu right>
                  <CardHeader styleName="align-items-center"
                    heading={<IntlMessages id="mailNotification.title" />} />
                  <MailNotification />
                </DropdownMenu>
              </Dropdown>
            </li>


            
            <li className="list-inline-item user-nav">

              <Dropdown
                className="quick-menu"
                isOpen={this.state.userInfo}
                toggle={this.onUserInfoSelect.bind(this)}>

                <Tooltip title={`${this.props.authUser.user_fnamn} ${this.props.authUser.user_lnamn}`} aria-label={`${this.props.authUser.user_fnamn} ${this.props.authUser.user_lnamn}`}>
                  <DropdownToggle
                    className="d-inline-block"
                    tag="span"
                    data-toggle="dropdown">
                    <IconButton className={`icon-btn ${parseInt(this.props.width)>700?"size-40":"size-30"} `}>
                      <Avatar className={`bg-primary ${parseInt(this.props.width)>700?"size-40":"size-30"} text-white newprimary`} onClick={this.handleClick} src={this.props.authUser.user_profile_pic}>{user_fnamn[0]}{user_lnamn[0]}</Avatar>
                    </IconButton>
                  </DropdownToggle>
                </Tooltip>

                <DropdownMenu right>
                  <UserInfoPopup toggle={this.onUserInfoSelect.bind(this)}/>

                </DropdownMenu>
              </Dropdown>
            </li>
            <li className="list-inline-item d-none d-md-inline-block">
              <Link to="/app/Help" target="_blank">
                <IconButton className="text-white" size="small">
                <img src={HelpIcon} style={{height: 30, width: 30, borderRadius: 10}}/>
              </IconButton>
              </Link>
            </li>

          </ul>
          {isUndefined(this.props.Flags)?"":this.props.Flags.Avtal === 1? 
          <PopUpSA
            open={this.state.AvtalOpen}
            handleClose={this.handleCloseAvtal}
          />
          :""}
          {isUndefined(this.props.Flags)?"":this.props.Flags.Prospekt === 1? 
          <PopUpSP
            open={this.state.ProspektOpen}
            handleClose={this.handleCloseProspekt}
          />
          :""}
          {
          
          parseInt(this.props.authUser.user_Licans) === 1?"":
          isUndefined(this.props.Flags)?"":this.props.Flags.OrderF === 1? 
          <PopUpSO
            open={this.state.SOrderOpen}
            handleClose={this.handleCloseSOrder}
          />
          :""}
          {isUndefined(this.props.Flags)?"":this.props.Flags.OrderF === 1? 
          <PopUpBM
            open={this.state.SEventOpen}
            handleClose={this.handleCloseSEvent}
            AnsvarigId={this.props.user_id}
            
          />
          :""}
          {
            isUndefined(this.props.Flags)?"":this.props.Flags.Aktiviteter === 1? 
            parseInt(this.props.authUser.user_CanSeeAktiviteter) === 1?
            <PopUpAk
            open={this.state.SAktivitetOpen}
            handleClose={this.handleCloseSAktivitet}
            AnsvarigId={this.props.user_id}            
            />
            :""
            :""
          }
          
          <PopUpES
            open={this.state.SEsigneringOpen}
            handleClose={this.handleCloseSEsignering}
            AnsvarigId={this.props.user_id}
            
          />
          <PopUpTR
            open={this.state.STidsrapportOpen}
            handleClose={this.handleCloseSTidsrapport}
            AnsvarigId={this.props.user_id}
            
          />
          <PopUpSkapaKund
            open={this.state.SKundOpen}
            handleClose={this.handleCloseSKund}
            AnsvarigId={this.props.user_id}
            
          />
          <PopUpSkapaAFNotis
            open={this.state.AFNotisOpen}
            handleClose={this.handleCloseAFNotisOpen}
            AnsvarigId={this.props.user_id}
            
          />
          <div className="ellipse-shape"></div>
        </Toolbar>
        {
          // isEmpty(this.state.difference)?"":
          // this.state.difference.map((notification, index)=>{
          //   this.notify(notification)
          // })
        }
        <ToastContainer
          className={classes.toastContainer}
        limit={3}></ToastContainer>
      </AppBar>
      
    );
  }

}

const mapStateToProps = ({ settings, auth,accountsData }) => {
  const { drawerType, locale, navigationStyle, horizontalNavPosition, navCollapsed,width } = settings;
  const { authUser, token, success,Notification,currentUserPicUrl } = auth;
  const { Flags, AFNotis,updatedashboardisMessage } = accountsData;
  return { drawerType, locale, navigationStyle, horizontalNavPosition, authUser, navCollapsed,currentUserPicUrl,AFNotis
  ,Flags,Notification,updatedashboardisMessage,width }
};

const styles = theme => ({
  badge: {
    top: 7,
    right: 7,
    transform: 'scale(0.8) translate(50%, -50%)'
  },
  AFNotis: {
    // backgroundColor: '#3dabb0'
    // backgroundColor: '#a175ff'
    background: 'rgb(161,117,255);',
    background: 'linear-gradient(151deg, #759aff 30%, rgb(95, 203, 208) 100%)'
  },
  toastContainer: {
    top: '4rem',
    right: '1rem'
  },
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { toggleCollapsedNav, switchLanguage,setSeenNotis,getMyUserProfilePic,setToastrThisNotis,setAFNotisSeen,onRefeshOutlookToken,
    setofUpdatedashboardisMessage,getAFNotis
  })
)(withRouter(Header))

// export default withRouter(connect(mapStateToProps, { toggleCollapsedNav, switchLanguage,setSeenNotis,getMyUserProfilePic,setToastrThisNotis })(Header));